











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.Dashboard.UpdateDashboardConfigCommand')
    
    export class UpdateDashboardConfigCommand {
        constructor( dashboardId: number, config: string ) {
            
                this.dashboardId = dashboardId;
            
                this.config = config;
            
        }

        
            public dashboardId: number;
        
            public config: string;
        
    }

    export interface IUpdateDashboardConfigCommand {
        
            dashboardId: number;
        
            config: string;
        
    }

    export async function updateDashboardConfig( command: UpdateDashboardConfigCommand ): Promise<CommandResult<void>>
    export async function updateDashboardConfig( { dashboardId, config }: IUpdateDashboardConfigCommand ): Promise<CommandResult<void>>
    export async function updateDashboardConfig( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof UpdateDashboardConfigCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new UpdateDashboardConfigCommand( model['dashboardId'], model['config'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace UpdateDashboardConfigCommand.ExtraneousTypes {
        

        
    }

